import { StateBadge } from '../../../ui/Badge';
import { Button } from '../../../ui/Button';
import { PageHeader } from '../../../ui/misc';
import type { AttemptDetail } from '../types';

const PROVENANCE_LABEL: Record<string, string> = {
  reported: 'Reported',
  verified: 'Verified',
  webhook: 'From GitHub',
};
export function AttemptHeader({
  a,
  rollback,
  setDialog,
}: {
  a: AttemptDetail;
  rollback: boolean | undefined;
  setDialog: (dialog: 'report' | 'reconcile' | 'verify' | 'correct' | null) => void;
}) {
  const b = a.binding;
  return (
    <PageHeader
      title={rollback ? `Rollback attempt ${a.attempt}` : `Deployment attempt ${a.attempt}`}
      subtitle={
        <>
          {a.release.displayId} · {a.release.title} → {b.environmentName}
        </>
      }
      actions={
        <>
          <StateBadge state={a.state} />
          {a.provenance && (
            <StateBadge state={a.provenance} label={PROVENANCE_LABEL[a.provenance] ?? a.provenance} />
          )}
          {a.viewer.canReport && (
            <Button size="sm" onClick={() => setDialog('report')}>
              Report outcome
            </Button>
          )}
          {a.viewer.canReconcile && (
            <Button size="sm" variant="secondary" onClick={() => setDialog('reconcile')}>
              Reconcile
            </Button>
          )}
          {a.viewer.canVerify && (
            <Button size="sm" variant="secondary" onClick={() => setDialog('verify')}>
              Verify
            </Button>
          )}
          {a.viewer.canCorrect && (
            <Button size="sm" variant="ghost" onClick={() => setDialog('correct')}>
              Record correction
            </Button>
          )}
        </>
      }
    />
  );
}
